module.exports = __webpack_public_path__ + "static/Playground-988bef3dde160b348bcb8c8365a738fd.webm";